export interface SetDialogMessageAction {
  type: 'SET_DIALOG_MESSAGE'
  title: string
  message: string
}

export interface ClearDialogAction {
  type: 'CLEAR_DIALOG'
}

export type DialogAction = SetDialogMessageAction | ClearDialogAction

export const setDialogMessage = (title: string, message: string): SetDialogMessageAction => ({
  type: 'SET_DIALOG_MESSAGE',
  title,
  message
})

export const clearDialog = (): ClearDialogAction => ({
  type: 'CLEAR_DIALOG'
})
